import { Outlet } from 'react-router-dom';

export default function Component() {
  return <Outlet />;
}
